export enum VerbosityLevel {
  ERRORS = 0,
  WARNINGS = 1,
  INFOS = 5,
}
